import React from 'react';
import LocationTemplate from './LocationTemplate';

const ElmCityPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Elm City"
      stateName="North Carolina"
      countyName="Wilson"
      zipCodes={["27822"]}
      latitude={35.8007}
      longitude={-77.8597}
      population={1217}
      historicalFact="Originally named Toisnot (after the creek), renamed Elm City in 1913."
      nearbyTowns={[
        "Wilson, NC",
        "Rocky Mount, NC",
        "Nashville, NC",
        "Spring Hope, NC",
        "Bailey, NC",
        "Sharpsburg, NC",
        "Black Creek, NC",
        "Lucama, NC"
      ]}
    />
  );
};

export default ElmCityPage;